import React from 'react';
import LoggedUserContext from '../model/auth/LoggedUserContext';

const AuthContext = React.createContext<LoggedUserContext>({}); // Create a context object

export default AuthContext;
